import React, { useState } from 'react'
import Env from '@/config/Env'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material'
import * as Yup from 'yup'

const QRCodeDialog = ({ isOpen, onClose, onGenerateQRCode }) => {
  const { t } = useTranslation()
  const [title, setTitle] = useState('')
  const [alt, setAlt] = useState('')
  const [dimension, setDimension] = useState('')
  const [formErrors, setFormErrors] = useState({})

  const validations = Yup.object().shape({
    title: Yup.string().required(t('general.required')),
    // alt: Yup.string().required(t('validation.tooltip')),
    dimension: Yup.number()
      .required(t('general.required'))
      .typeError(t('general.required'))
      .min(100, t('validation.qr_min_size'))
      .max(400, t('validation.qr_max_size')),
  })

  const handleGenerateQRCode = () => {
    validations
      .validate({ title, dimension }, { abortEarly: false })
      .then(() => {
        console.log('Validation successful. Generating QR code...')
        const imageUrl = `id=qrcode src="${Env.QRCODE_URL}" alt="${alt}" title="${title}" width="${dimension}" height="${dimension}"`
        onGenerateQRCode(imageUrl)
        onClose()
      })
      .catch(error => {
        const newErrors = {}
        error.inner.forEach(err => {
          newErrors[err.path] = err.message
        })
        setFormErrors(newErrors)
      })
  }

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{t('tinymce.toolbar.qrcode')}</DialogTitle>
      <DialogContent>
        <TextField
          label={`${t('tinymce.dialogs.qrcode.title_text')}`}
          variant="outlined"
          value={title}
          name="title"
          onChange={e => setTitle(e.target.value)}
          onFocus={() => setFormErrors(prev => ({ ...prev, title: '' }))} // 點擊時清除錯誤
          fullWidth
          margin="normal"
          error={Boolean(formErrors.title)}
          helperText={formErrors.title}
        />
        <TextField
          label={`${t('tinymce.dialogs.qrcode.replace_text')}`}
          variant="outlined"
          value={alt}
          name="tooltip"
          onChange={e => setAlt(e.target.value)}
          fullWidth
          margin="normal"
          error={Boolean(formErrors.alt)}
          helperText={formErrors.alt}
        />
        <TextField
          label={`${t('tinymce.dialogs.qrcode.width')} & ${t('tinymce.dialogs.qrcode.length')} (${t(
            'tinymce.dialogs.qrcode.tips',
          )})`}
          variant="outlined"
          type="number"
          value={dimension}
          name="size"
          onChange={e => setDimension(e.target.value)}
          onFocus={() => setFormErrors(prev => ({ ...prev, dimension: '' }))} // 點擊時清除錯誤
          fullWidth
          margin="normal"
          error={Boolean(formErrors.dimension)}
          helperText={formErrors.dimension}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="secondary">
          {t('tinymce.dialogs.qrcode.close')}
        </Button>
        <Button onClick={handleGenerateQRCode} variant="contained" color="primary">
          {t('tinymce.dialogs.qrcode.insert')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default QRCodeDialog
